import { Directive, ElementRef } from '@angular/core';

@Directive({
  selector: '[appDmask]'
})

export class DmaskDirective {


  constructor({ nativeElement }: ElementRef<HTMLInputElement>) {
    const supports = 'mask' in HTMLInputElement.prototype;

    console.log( nativeElement.getAttribute('mask'))
    nativeElement.removeAttribute('mask')
    if (supports) {
      nativeElement.setAttribute('mask', 'separator.3');
    } else {
      nativeElement.setAttribute('mask', 'separator.3');
      // fallback to IntersectionObserver
    }
    
    console.log( nativeElement.getAttribute('mask'))
  }
}
